import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  Typography,
  Button,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import SvgIconStyle from "../../components/SvgIconStyle";
// hooks
import useResponsive from '../../hooks/useResponsive';


export default function WorkingTermsDialog({ isOpen, close}) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="dg">
      <DialogContent sx={{ p: { xs: 3, sm: 4 }, pb: "0!important" }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          업무 조건, 이렇게 작성해보세요.
        </Typography>

        <Typography variant="subtitle1" paragraph>
          주당 업무 시간
        </Typography>

        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 1.5 }}>
          <SvgIconStyle src={`/icons/icon-clock-mono.svg`} sx={{ minWidth: 20, width: 20, minHeight: 22, height: 22, color: "text.secondary" }} />
          <Typography variant="body2">
            다른 크루들은 보통 퇴근 후와, 주말을 이용해<br />
            평균적으로 주당 15시간 일하고 있어요.
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="flex-start">
          <SvgIconStyle src={`/icons/icon-chat-bubble-dots-mono.svg`} sx={{ minWidth: 20, width: 20, minHeight: 22, height: 22, color: "text.secondary" }} />
          <Typography variant="body2">
            실제로 몇시간 업무를 진행할지는 사전미팅에서 회사와 논의할 수 있어요.
          </Typography>
        </Stack>

        <Divider sx={{ my: 3 }} />

        <Typography variant="subtitle1" paragraph>
          4주 인건비
        </Typography>

        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 1.5 }}>
          <SvgIconStyle src={`/icons/icon-coin-mono.svg`} sx={{ minWidth: 20, width: 20, minHeight: 22, height: 22, color: "text.secondary" }} />
          <Typography variant="body2">
            사전 미팅에서 업무 범위를 확정한 후 최종 금액을 다시 제안할 수 있어요.
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 1.5 }}>
          <SvgIconStyle src={`/icons/icon-chat-bubble-dots-mono.svg`} sx={{ minWidth: 20, width: 20, minHeight: 22, height: 22, color: "text.secondary" }} />
          <Stack sx={{ width: 1 }}>
            <Typography variant="body2" gutterBottom>
              업무 범위가 모호해서 금액 책정이 어렵다면, <br/>
              [질문 또는 업무 범위 수정 제안]에 아래와 같이 적어주세요.
            </Typography>
            <Box
              sx={{
                px: 2,
                py: 1.5,
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: (theme) => theme.palette.grey[500_32],
              }}>
            <Typography variant="caption">
              금액은 사전 미팅에서 업무 범위를 확정한 후 조정될 수 있습니다.
            </Typography>
            </Box>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            sx={{ justifyContent: 'start', color: 'text.secondary' }}
            endIcon={<Iconify icon="ic:chevron-right" />}
            size="small"
            onClick={() => {window.open('https://dio.oopy.io/faq-price')}}
          >
            평균 계약 금액 보러가기
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button
          onClick={close}
          variant="contained"
          size="large"
          sx={{ px: 5 }}
          fullWidth={!smUp}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}